export default __webpack_public_path__ + "static/media/arrow-data-action.d4d973fd.svg";